import { postUpdateProject } from "lib/api/postUpdateProject.js";
import { postUpdateFile } from "lib/api/postUpdateFile.js";
import { useAppStore } from "lib/store/useAppStore.js";

export function isEditorFormChanged(current, draft) {
  if (!draft) return false;
  return Object.keys(draft).some((key) => current?.[key] !== draft?.[key]);
}

export async function saveEditorDraft({
  type,
  draft,
  current,
  setForm,
  setPrevData,
  setIsReadOnly,
  setdata,
  userId,
  projectId,
  refetch,
  t,
}) {
  const { fetchProjectTree, showAlert } = useAppStore.getState();

  try {
    let result = {};

    if (type === "project") {
      result = await postUpdateProject(draft);
    } else if (type === "file") {
      result = await postUpdateFile(draft);
    } else {
      showAlert({
        text: t?.("editorBtnBox.invalidType") ?? "Invalid editor type.",
        success: false,
        autoClose: true,
      });
      return { success: false, result: null };
    }

    if (!result?.success) {
      showAlert({
        text:
          result?.message ??
          t?.("editorBtnBox.updateFailedFallback") ??
          "Update failed.",
        messageKey: result?.messageKey,
        messageParams: result?.messageParams,
        success: false,
        autoClose: true,
      });
      return { success: false, result };
    }

    if (typeof setForm === "function") {
      setForm((prev) => ({ ...(prev ?? {}), ...(draft ?? {}) }));
    }

    if (typeof setdata === "function") {
      setdata((prev) => ({ ...(prev ?? {}), ...(draft ?? {}) }));
    }

    if (typeof setPrevData === "function") {
      setPrevData((prev) => ({ ...(prev ?? {}), ...(draft ?? {}) }));
    }

    if (typeof setIsReadOnly === "function") {
      setIsReadOnly(false);
    }

    if (userId) {
      fetchProjectTree(userId, projectId);
    }

    if (typeof refetch === "function") {
      await refetch();
    }

    showAlert({
      text:
        result?.message ??
        t?.("editorBtnBox.updateSuccessFallback") ??
        "Updated successfully.",
      messageKey: result?.messageKey,
      messageParams: result?.messageParams,
      success: true,
      autoClose: true,
    });

    return { success: true, result };
  } catch (error) {
    console.error("saveEditorDraft failed:", error);
    showAlert({
      text:
        t?.("editorBtnBox.updateFailedFallback") ?? "Update failed.",
      success: false,
      autoClose: true,
    });
    return { success: false, result: null };
  }
}

export function openEditorDraft({ form, setPrevData, setIsReadOnly }) {
  if (typeof setPrevData === "function") {
    setPrevData(form);
  }

  if (typeof setIsReadOnly === "function") {
    setIsReadOnly((prev) => !prev);
  }
}

export function buildEditorSavePayload(props = {}, t) {
  return {
    type: props.type,
    draft: props.prevData,
    current: props.form,
    setForm: props.setForm,
    setPrevData: props.setPrevData,
    setIsReadOnly: props.setIsReadOnly,
    setdata: props.setdata,
    userId: props.user_id,
    projectId: props.project_id,
    refetch: props.refetch,
    t,
  };
}
